import { Game } from './Game';

document.addEventListener('DOMContentLoaded', () => {
  const canvas = document.getElementById('gameCanvas') as HTMLCanvasElement;
  
  if (!canvas) {
    console.error('Canvas element not found');
    return;
  }

  const game = new Game(canvas);
  game.start();

  console.log('Shooting game started!');
  console.log('Controls:');
  console.log('- Arrow keys or A/D: Move');
  console.log('- Space or Z: Shoot');
});